exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#callbackPrompt {\n  position: relative;\n  margin: 80px auto 0 auto; }\n  #callbackPrompt h4 {\n    text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/app/callback/callback.component.scss
// module id = ../../../../../src/app/callback/callback.component.scss
// module chunks = main